import * as types from '../actions/actionTypes'

const ui = (state = {}, action) => {
  switch (action.type) {
    case types.SET_VIDEO_DATA:
      return {
        ...state,
        videoData: action.videoData,
      }
    case types.CLEAR_ALL_ERRORS:
      return {
        ...state,
        err: {},
      }
    case types.INVALID_PHONE:
      return {
        ...state,
        err: {
          phone: action.msg,
        },
      }
    case types.INVALID_CODE:
      return {
        ...state,
        err: {
          code: action.msg,
        },
      }
    case types.EMPTY_FIELDS:
      return {
        ...state,
        err: {
          emptyErr: action.msg,
        },
      }
    case types.SET_USER_PHONE:
      return { ...state, phone: action.phone }
    case types.DELETE_PHONE_NUMBER:
      return { ...state, phone: undefined }
    case types.INVALID_AVATAR:
      return {
        ...state,
        err: {
          imgErr: action.msg,
        },
      }
    default:
      return state
  }
}

export default ui



// WEBPACK FOOTER //
// ./src/reducers/ui.js